import React from 'react';
import PropTypes from 'prop-types';

import contractPage from 'hoc/contractPage/contractPage';

import ContractTemplate from '../patterns/ContractTemplate/ContractTemplate';

export function Lending({ pageContent }) {
  return (
    <ContractTemplate title="Contrato Empréstimo Pessoal">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: pageContent }} />
    </ContractTemplate>
  );
}

Lending.propTypes = {
  pageContent: PropTypes.string.isRequired,
};

export default contractPage(Lending, {
  routeKey: 'LENDING_CONTRACT',
  googleDocumentId: '1v-fGj748-WoRnZoKtlS5NMv99QsJxCazrJMqPpJgyXg',
});
